<template>
  <ProgressCircular v-if="loading" />
  <v-expansion-panels v-else>
    <template v-for="(entity, idx) in $options.entityList">
          <v-expansion-panel v-if="$props[entity.value] && $props[entity.value].length" :key="idx + entity.value">
      <v-expansion-panel-header> {{entity.title}}({{ $props[entity.value].length }}) </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list>
          <v-list-item v-for="ent in $props[entity.value]" :key="ent.id">
            <router-link :to="returnLink(ent)">{{ getContentTitle(ent) }}</router-link>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import { mixForm } from '@/utils/form.mix.js'
import entityList from '@/configs/entityList'
import { getLinkEntity } from '@/utils/getLinkEntity'

import ProgressCircular from '@/components/progress-circular'

export default {
  name: 'RelationComponent',
  mixins: [mixForm],
  entityList,
  props: {
    events: {
      type: Array,
      default: () => null
    },
    routes: {
      type: Array,
      default: () => null
    },
    audioguides: {
      type: Array,
      default: () => null
    },
    culturalOrganizations: {
      type: Array,
      default: () => null
    },
    eventOrganizers: {
      type: Array,
      default: () => null
    },
    touristAgencies: {
      type: Array,
      default: () => null
    },
    hotels: {
      type: Array,
      default: () => null
    },
    guides: {
      type: Array,
      default: () => null
    },
    sharedAccess: {
      type: Array,
      default: () => null
    },
    ticketReservations: {
      type: Array,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProgressCircular
  },
  computed: {
    getTitle () {
      return this.name
    }
  },
  methods: {
    getContentTitle (el) {
      if (el?.title) return el.title
      if (el?.organizationName) return el.organizationName
      if (el?.name) return el.name
      if (el?.organizerName) return el.organizerName
      if (el?.fullName || el?.email || el?.phone) return el.fullName || el.email || el.phone
      if (el?.displayName) return el.displayName
      return ''
    },
    getLinkEntity,
    returnLink (ent) {
      if (ent.__typename !== 'SharedAccess') {
        return this.getLinkEntity(ent)
      }
      return this.redirectToSharedAccess
    }
  }
}
</script>
